import type { LifeEvent } from '../../types/onelife.ts';

export const ADULTHOOD_EVENTS: LifeEvent[] = [
  {
    "id": "adul_01_holy_matrimony",
    "stageKey": "adulthood",
    "age": 26,
    "titleVi": "Bí Tích Hôn Phối Tại Thánh Đường",
    "descriptionVi": "Trong ngôi thánh đường tôn nghiêm, trước bàn thờ Chúa và sự chứng kiến của hai họ, bạn cùng người bạn đời trao lời thề hứa chung thủy trọn đời.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_01_a",
        "textVi": "Cùng thề hứa yêu thương, tôn trọng nhau khi thịnh vượng cũng như lúc gian nan trong Bí Tích Hôn Phối",
        "outcomeTextVi": "Gia đình bạn được thánh hiến trong ân sủng Bí Tích Hôn Phối, mở ra mái ấm tràn ngập tiếng cười và phúc lành.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "unlockRelationship": "Đã Kết Hôn Trong Bí Tích Hôn Phối",
        "addSacrament": "Bí Tích Hôn Phối",
        "addVirtue": "Thề hứa trung kiên sống trọn vẹn ơn gọi của Bí Tích Hôn Phối"
      },
      {
        "id": "adul_01_b",
        "textVi": "Tổ chức đám cưới ấm cúng, dành tiền tiết kiệm giúp đỡ các gia đình nghèo",
        "outcomeTextVi": "Hôn lễ giản dị nhưng thấm đẫm tình bác ái được hai họ và cộng đoàn hết lòng ca ngợi.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 30,
        "unlockRelationship": "Đã Kết Hôn Ấm Cúng",
        "addSacrament": "Bí Tích Hôn Phối"
      }
    ]
  },
  {
    "id": "adul_02_civil_wedding",
    "stageKey": "adulthood",
    "age": 26,
    "titleVi": "Ngày Hạnh Phúc Trăm Năm",
    "descriptionVi": "Lễ thành hôn rộn ràng pháo hoa và tiếng cười chúc phúc của gia đình, bạn bè và đồng nghiệp.",
    "category": "love",
    "choices": [
      {
        "id": "adul_02_a",
        "textVi": "Trao nhẫn cưới và hẹn ước cùng nhau vun đắp tổ ấm vững bền",
        "outcomeTextVi": "Hai trái tim hòa chung một nhịp, bắt đầu hành trình xây dựng tương lai chung.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -25,
        "intellectDelta": 5,
        "relationsDelta": 30,
        "unlockRelationship": "Đã Kết Hôn Hạnh Phúc"
      },
      {
        "id": "adul_02_b",
        "textVi": "Cùng nhau đi tuần trăng mật khám phá vùng biển hoang sơ",
        "outcomeTextVi": "Những ngày tháng ngọt ngào tiếp thêm nguồn năng lượng dồi dào cho cả hai.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": -20,
        "intellectDelta": 5,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "adul_03_first_child_born",
    "stageKey": "adulthood",
    "age": 28,
    "titleVi": "Đón Thiên Thần Nhỏ Chào Đời",
    "descriptionVi": "Tiếng khóc chào đời của đứa con đầu lòng vang lên trong phòng sinh khiến bạn rưng rưng giọt lệ hạnh phúc.",
    "category": "family",
    "choices": [
      {
        "id": "adul_03_a",
        "textVi": "Bế thiên thần nhỏ vào lòng và hứa sẽ bảo bọc con bằng tất cả tình yêu",
        "outcomeTextVi": "Thiên chức làm cha/mẹ thiêng liêng biến bạn thành một con người đầy trách nhiệm và trưởng thành.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 30,
        "addChildren": 1,
        "unlockAchievement": "Gia Đình Đón Con Đầu Lòng"
      },
      {
        "id": "adul_03_b",
        "textVi": "Tận tình túc trực chăm sóc người bạn đời sau ca sinh nở",
        "outcomeTextVi": "Tình cảm vợ chồng sau biến cố sinh tử càng thêm khăng khít, bền chặt.",
        "healthDelta": -5,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addChildren": 1,
        "addVirtue": "Tận tụy chăm sóc bạn đời và con thơ trong giờ phút thiêng liêng"
      }
    ]
  },
  {
    "id": "adul_04_baby_baptism",
    "stageKey": "adulthood",
    "age": 28,
    "titleVi": "Dâng Con Nhỏ Trong Bí Tích Rửa Tội",
    "descriptionVi": "Gia đình mang em bé đến nhà thờ xin Cha xứ cử hành Bí Tích Rửa Tội và chọn Thánh Bổn Mạng che chở.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_04_a",
        "textVi": "Cùng cha mẹ đỡ đầu sốt sắng tuyên xưng đức tin và dâng con trong Bí Tích Rửa Tội",
        "outcomeTextVi": "Con bạn được tái sinh trong ân sủng Bí Tích Rửa Tội, cả gia đình ngập tràn phúc lành.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 25,
        "addVirtue": "Nuôi dưỡng con cái lớn lên trong tình yêu Chúa và gia sản đức tin"
      },
      {
        "id": "adul_04_b",
        "textVi": "Mở tiệc mừng nhỏ ấm cúng tạ ơn cùng họ hàng nội ngoại",
        "outcomeTextVi": "Bà con chòm xóm đến chúc phúc cho em bé hay ăn chóng lớn, ngoan ngoãn.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": -15,
        "intellectDelta": 5,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_05_buying_home",
    "stageKey": "adulthood",
    "age": 30,
    "titleVi": "Mua Ngôi Nhà An Cư Lạc Nghiệp",
    "descriptionVi": "Sau nhiều năm tích lũy và vay ngân hàng với kế hoạch tài chính chặt chẽ, bạn nhận sổ hồng ngôi nhà đầu tiên.",
    "category": "career",
    "choices": [
      {
        "id": "adul_05_a",
        "textVi": "Tự tay sắp xếp từng góc phòng, dựng bàn thờ gia tiên / bàn thờ Chúa nơi trang trọng nhất",
        "outcomeTextVi": "Cảm giác an cư mang lại sự tự tin tột bậc để bạn phát triển sự nghiệp dài hạn.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 40,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "unlockAchievement": "An Cư Lạc Nghiệp"
      },
      {
        "id": "adul_05_b",
        "textVi": "Trồng vườn cây xanh mướt quanh hiên nhà tạo không gian sống trong lành",
        "outcomeTextVi": "Ngôi nhà trở thành tổ ấm bình yên đón các thành viên trở về sau ngày dài bận rộn.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": 30,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "adul_06_promotion_manager",
    "stageKey": "adulthood",
    "age": 31,
    "titleVi": "Thăng Chức Giám Đốc Bộ Phận / Trưởng Phòng",
    "descriptionVi": "Ban Giám Đốc tín nhiệm bổ nhiệm bạn lãnh đạo khối tác nghiệp với hơn 30 nhân sự dưới quyền.",
    "category": "career",
    "choices": [
      {
        "id": "adul_06_a",
        "textVi": "Lãnh đạo bằng sự thấu hiểu, xây dựng văn hóa làm việc tôn trọng và hiệu quả",
        "outcomeTextVi": "Đội ngũ đoàn kết một lòng, doanh thu và năng suất phòng ban tăng trưởng vượt bậc.",
        "healthDelta": -5,
        "happinessDelta": 25,
        "wealthDelta": 35,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "careerTag": "Trưởng Phòng Điều Hành Cấp Cao"
      },
      {
        "id": "adul_06_b",
        "textVi": "Cải tiến mạnh mẽ quy trình tự động hóa giúp giảm tải áp lực cho nhân viên",
        "outcomeTextVi": "Mọi người nể phục tài năng lãnh đạo và tinh thần phụng sự của bạn.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 30,
        "intellectDelta": 30,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "adul_07_family_evening_prayer",
    "stageKey": "adulthood",
    "age": 32,
    "titleVi": "Giờ Kinh Tối Gia Đình Đầm Ấm",
    "descriptionVi": "Sau bữa cơm tối, gia đình tắt tivi, quây quần trước bàn thờ Chúa đọc kinh Mân Côi và tạ ơn.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_07_a",
        "textVi": "Duy trì đều đặn lời kinh tối gia đình, dạy con trẻ dâng ngày cho Chúa",
        "outcomeTextVi": "Lời kinh đơn sơ giữ cho tổ ấm luôn êm ấm, thuận hòa và bình yên trước mọi bão táp.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Gìn giữ nề nếp kinh nguyện gia đình Công giáo sốt sắng mỗi ngày"
      },
      {
        "id": "adul_07_b",
        "textVi": "Dành 15 phút sau giờ kinh lắng nghe con cái tâm sự chuyện trường lớp",
        "outcomeTextVi": "Tình cảm cha mẹ và con cái trở nên vô cùng gắn bó, thấu hiểu.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_08_midlife_health_scare",
    "stageKey": "adulthood",
    "age": 33,
    "titleVi": "Cảnh Báo Sức Khỏe Tuổi Ngoài 30",
    "descriptionVi": "Làm việc quá sức và thức khuya khiến chỉ số huyết áp và gan nhiễm mỡ của bạn báo động.",
    "category": "health",
    "choices": [
      {
        "id": "adul_08_a",
        "textVi": "Lập tức thay đổi lối sống: chạy bộ mỗi sáng, giảm bia rượu và ăn nhiều rau củ",
        "outcomeTextVi": "Sau 3 tháng, các chỉ số xét nghiệm trở về mức bình thường, thể trạng dẻo dai trở lại.",
        "healthDelta": 25,
        "happinessDelta": 20,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 10,
        "addVirtue": "Biết quý trọng sinh mệnh và giữ gìn đền thờ thân xác Chúa ban"
      },
      {
        "id": "adul_08_b",
        "textVi": "Tham gia lớp yoga và thiền định cuối tuần cùng bạn đời",
        "outcomeTextVi": "Tâm trí thanh thản, giảm bớt căng thẳng công việc rõ rệt.",
        "healthDelta": 20,
        "happinessDelta": 25,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "adul_09_business_expansion",
    "stageKey": "adulthood",
    "age": 34,
    "titleVi": "Mở Rộng Chi Nhánh Kinh Doanh / Nhà Xưởng",
    "descriptionVi": "Doanh nghiệp của bạn mở thêm cơ sở sản xuất mới tại khu công nghiệp lân cận.",
    "category": "career",
    "choices": [
      {
        "id": "adul_09_a",
        "textVi": "Đầu tư dây chuyền máy móc hiện đại và đào tạo tay nghề cho công nhân địa phương",
        "outcomeTextVi": "Nhà xưởng vận hành trơn tru, tạo công ăn việc làm ổn định cho hơn 50 lao động.",
        "healthDelta": -5,
        "happinessDelta": 30,
        "wealthDelta": 45,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "careerTag": "Doanh Nhân Phát Triển Bền Vững",
        "unlockAchievement": "Tạo Dựng Việc Làm Xã Hội"
      },
      {
        "id": "adul_09_b",
        "textVi": "Chú trọng chính sách phúc lợi bữa ăn và bảo hộ lao động chu đáo cho người lao động",
        "outcomeTextVi": "Công nhân gắn bó xem nhà xưởng như gia đình thứ hai.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 30,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Kinh doanh có tâm, đối xử công bằng nhân ái với người lao động"
      }
    ]
  },
  {
    "id": "adul_10_second_child",
    "stageKey": "adulthood",
    "age": 32,
    "titleVi": "Gia Đình Đón Thêm Thành Viên Thứ Hai",
    "descriptionVi": "Gia đình có thêm một bé gái kháu khỉnh, \"đủ nếp đủ tẻ\" trong niềm vui khôn xiết của hai họ.",
    "category": "family",
    "choices": [
      {
        "id": "adul_010_a",
        "textVi": "Dạy con lớn cách yêu thương nhường nhịn em nhỏ",
        "outcomeTextVi": "Hai con yêu thương đùm bọc nhau, căn nhà luôn đầy ắp tiếng cười khúc khích.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addChildren": 1
      },
      {
        "id": "adul_010_b",
        "textVi": "Lên kế hoạch bảo hiểm giáo dục cho cả hai con vững bước tương lai",
        "outcomeTextVi": "Tương lai học tập của các con được bảo đảm vững chắc.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addChildren": 1
      }
    ]
  },
  {
    "id": "adul_11_parish_council",
    "stageKey": "adulthood",
    "age": 35,
    "titleVi": "Hội Đồng Mục Vụ Giáo Xứ",
    "descriptionVi": "Cộng đoàn giáo dân tín nhiệm bầu bạn tham gia Hội Đồng Mục Vụ Giáo Xứ phụ trách ban bác ái.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_11_a",
        "textVi": "Tận tụy đóng góp công sức tổ chức các chương trình bác ái Caritas giúp đỡ người khó khăn",
        "outcomeTextVi": "Nhiều mảnh đời cơ nhỡ được nâng đỡ, uy tín và lòng đạo hạnh của bạn sáng ngời.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Phụng sự cộng đoàn giáo xứ bằng tinh thần vô vị lợi và đức ái Kitô giáo"
      },
      {
        "id": "adul_11_b",
        "textVi": "Tham gia trùng tu ngôi nhà thờ cổ kính của quê hương",
        "outcomeTextVi": "Ngôi thánh đường khang trang là di sản thiêng liêng để lại cho muôn đời con cháu.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -15,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_12_marital_crisis_reconciliation",
    "stageKey": "adulthood",
    "age": 34,
    "titleVi": "Hàn Gắn Bất Đồng Hôn Nhân",
    "descriptionVi": "Áp lực mưu sinh và nuôi dạy con cái đôi lúc tạo nên khoảng cách giữa hai vợ chồng.",
    "category": "love",
    "choices": [
      {
        "id": "adul_12_a",
        "textVi": "Chủ động hạ cái tôi, dành một buổi tối riêng tư đối thoại chân thành và xin lỗi nhau",
        "outcomeTextVi": "Tình yêu được tôi luyện qua thử thách, hai vợ chồng càng thêm trân trọng nhau.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Biết khiêm nhường xin lỗi và nhẫn nại gìn giữ hôn nhân bền vững"
      },
      {
        "id": "adul_12_b",
        "textVi": "Cùng nhau tham gia khóa Linh Thao / Tĩnh Tâm Hôn Nhân Gia Đình",
        "outcomeTextVi": "Ân sủng Chúa hòa giải và tái sinh ngọn lửa yêu thương nồng nàn như thuở ban đầu.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": -5,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "adul_13_flood_relief",
    "stageKey": "adulthood",
    "age": 36,
    "titleVi": "Cứu Trợ Đồng Bào Vùng Lũ Quét",
    "descriptionVi": "Trận đại hồng thủy tàn phá các tỉnh miền Trung, hàng nghìn gia đình mất trắng nhà cửa.",
    "category": "society",
    "choices": [
      {
        "id": "adul_13_a",
        "textVi": "Trực tiếp lái xe tải chở áo phao, nước sạch và thuốc men vào rốn lũ cứu trợ",
        "outcomeTextVi": "Sự có mặt kịp thời của bạn cứu sống nhiều người dân đang bị cô lập trên nóc nhà.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Dấn thân vào nơi hiểm nguy cứu giúp đồng bào trong hoạn nạn bão lũ",
        "unlockAchievement": "Người Hùng Cứu Trợ"
      },
      {
        "id": "adul_13_b",
        "textVi": "Quyên góp tiền xây dựng 2 căn nhà phao chống lũ tặng các hộ nghèo",
        "outcomeTextVi": "Món quà nghĩa tình giúp người dân yên tâm vượt qua những mùa mưa bão sau.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": -25,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_14_scientific_paper",
    "stageKey": "adulthood",
    "age": 35,
    "titleVi": "Công Bố Sáng Chế / Bài Báo Khoa Học Quốc Tế",
    "descriptionVi": "Công trình nghiên cứu công nghệ xanh / y học của bạn được đăng tải trên tạp chí khoa học uy tín.",
    "category": "education",
    "choices": [
      {
        "id": "adul_14_a",
        "textVi": "Chuyển giao công nghệ cho doanh nghiệp trong nước áp dụng thực tiễn",
        "outcomeTextVi": "Sáng chế giúp tiết kiệm hàng triệu kilowatt điện, mang lại lợi ích to lớn cho xã hội.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": 40,
        "intellectDelta": 35,
        "relationsDelta": 20,
        "unlockEducation": "Nhà Khoa Học Ứng Dụng Hàng Đầu"
      },
      {
        "id": "adul_14_b",
        "textVi": "Mở mã nguồn mở và tài liệu miễn phí cho cộng đồng nghiên cứu",
        "outcomeTextVi": "Hàng ngàn sinh viên và nhà nghiên cứu trên thế giới hưởng lợi từ công trình của bạn.",
        "healthDelta": 0,
        "happinessDelta": 35,
        "wealthDelta": 10,
        "intellectDelta": 35,
        "relationsDelta": 35,
        "addVirtue": "Cống hiến tri thức vô vụ lợi cho sự tiến bộ của nhân loại"
      }
    ]
  },
  {
    "id": "adul_15_parent_care",
    "stageKey": "adulthood",
    "age": 37,
    "titleVi": "Phụng Dưỡng Cha Mẹ Lúc Tuổi Già Đau Yếu",
    "descriptionVi": "Cha mẹ bước vào tuổi thất thập, sức khỏe giảm sút với những cơn đau khớp và tim mạch.",
    "category": "family",
    "choices": [
      {
        "id": "adul_15_a",
        "textVi": "Đón cha mẹ về sống chung, tự tay nấu những món ăn mềm thanh đạm mỗi ngày",
        "outcomeTextVi": "Cha mẹ ấm lòng sống bên con cháu, nụ cười an vui làm ấm cả ngôi nhà.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 5,
        "relationsDelta": 40,
        "addVirtue": "Chữ Hiếu vẹn toàn phụng dưỡng đấng sinh thành lúc tuổi già bóng xế"
      },
      {
        "id": "adul_15_b",
        "textVi": "Thuê chuyên gia vật lý trị liệu và đưa cha mẹ đi điều dưỡng hàng tháng",
        "outcomeTextVi": "Sức khỏe cha mẹ ổn định, luôn tự hào có người con hiếu thảo, chu đáo.",
        "healthDelta": 0,
        "happinessDelta": 25,
        "wealthDelta": -25,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_16_stock_market_bubble",
    "stageKey": "adulthood",
    "age": 36,
    "titleVi": "Khủng Hoảng Bong Bóng Tài Chính",
    "descriptionVi": "Cơn sốt đất đai và cổ phiếu khiến nhiều người đổ xô vay nợ đầu cơ liều lĩnh.",
    "category": "career",
    "choices": [
      {
        "id": "adul_16_a",
        "textVi": "Giữ vững sự tỉnh táo, không tham lam và chỉ đầu tư vào sản xuất kinh doanh cốt lõi",
        "outcomeTextVi": "Khi thị trường sụp đổ, bạn bình an vô sự và bảo toàn trọn vẹn gia sản cho con cái.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 30,
        "intellectDelta": 25,
        "relationsDelta": 20,
        "addVirtue": "Thận trọng, liêm khiết không chạy theo lòng tham phù phiếm"
      },
      {
        "id": "adul_16_b",
        "textVi": "Giúp đỡ bạn bè thân thiết thoát khỏi bẫy nợ xấu tài chính",
        "outcomeTextVi": "Lời khuyên can chân tình của bạn cứu vãn nhiều gia đình khỏi cảnh khánh kiệt.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "adul_17_caritas_scholarship",
    "stageKey": "adulthood",
    "age": 38,
    "titleVi": "Thành Lập Quỹ Khuyến Học Cho Trẻ Em Nghèo",
    "descriptionVi": "Bạn trích một phần lợi nhuận hàng năm thành lập học bổng tiếp sức cho học sinh nghèo hiếu học.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_17_a",
        "textVi": "Đỡ đầu học phí cho 20 em học sinh nghèo suốt những năm đại học",
        "outcomeTextVi": "Nhiều em sau này thành tài trở thành bác sĩ, kỹ sư quay lại phụng sự quê hương.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -20,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Gieo mầm tri thức và nâng đỡ tương lai cho trẻ em nghèo khó"
      },
      {
        "id": "adul_17_b",
        "textVi": "Xây dựng thư viện cộng đồng miễn phí với hàng nghìn đầu sách hay",
        "outcomeTextVi": "Thư viện trở thành điểm đến yêu thích của trẻ em cả vùng quê.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -20,
        "intellectDelta": 20,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_18_chess_grandmaster_mentor",
    "stageKey": "adulthood",
    "age": 36,
    "titleVi": "Truyền Thụ Kỳ Nghệ Cho Thế Hệ Kế Cận",
    "descriptionVi": "Bạn mở lớp cờ tướng / cờ vua miễn phí tại nhà văn hóa truyền dạy trí tuệ cho thiếu nhi.",
    "category": "education",
    "choices": [
      {
        "id": "adul_18_a",
        "textVi": "Đào tạo học trò đoạt huy chương Vàng giải vô địch trẻ quốc gia",
        "outcomeTextVi": "Học trò tôn kính bạn như người thầy mẫu mực, tài hoa và đức độ.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": 10,
        "intellectDelta": 25,
        "relationsDelta": 30
      },
      {
        "id": "adul_18_b",
        "textVi": "Dạy học trò học chữ \"Nhẫn\" và chữ \"Tâm\" qua từng nước cờ",
        "outcomeTextVi": "Các em không chỉ chơi cờ giỏi mà còn trở thành những công dân đạo đức.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 20,
        "relationsDelta": 30,
        "addVirtue": "Dạy người trước khi dạy nghề, truyền thụ đạo đức cho thế hệ trẻ"
      }
    ]
  },
  {
    "id": "adul_19_traffic_safe_driver",
    "stageKey": "adulthood",
    "age": 37,
    "titleVi": "10 Năm Lái Xe Không Một Vết Xước",
    "descriptionVi": "Bạn nhận bằng khen \"Tài xế gương mẫu an toàn giao thông\" sau 10 năm cầm lái hàng vạn cây số.",
    "category": "health",
    "choices": [
      {
        "id": "adul_19_a",
        "textVi": "Luôn giữ tâm thế bình thản, nhường đường cho người đi bộ và xe cấp cứu",
        "outcomeTextVi": "Tác phong điềm đạm bảo đảm bình an trọn vẹn cho bản thân và gia đình.",
        "healthDelta": 15,
        "happinessDelta": 20,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 15
      },
      {
        "id": "adul_19_b",
        "textVi": "Cứu giúp người bị hỏng xe giữa đèo dốc ban đêm",
        "outcomeTextVi": "Nghĩa cử hào hiệp được chia sẻ rộng rãi, lan tỏa tinh thần tử tế trên đường.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 25
      }
    ]
  },
  {
    "id": "adul_20_village_bridge",
    "stageKey": "adulthood",
    "age": 39,
    "titleVi": "Xây Cây Cầu Bê Tông Nối Nhịp Bờ Vui",
    "descriptionVi": "Cây cầu khỉ tạm bợ ở làng quê thường xuyên khiến học sinh trượt ngã mỗi mùa nước lũ.",
    "category": "society",
    "choices": [
      {
        "id": "adul_20_a",
        "textVi": "Vận động bạn bè doanh nhân cùng góp vốn xây dựng cây cầu bê tông kiên cố",
        "outcomeTextVi": "Cây cầu hoàn thành trong niềm vui vỡ òa của bà con và hàng trăm em nhỏ cắp sách đến trường.",
        "healthDelta": 5,
        "happinessDelta": 40,
        "wealthDelta": -30,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Nối nhịp bờ vui, dựng xây công trình phúc lợi cho quê hương",
        "unlockAchievement": "Nhà Kiến Thiết Quê Hương"
      },
      {
        "id": "adul_20_b",
        "textVi": "Lắp thêm hệ thống đèn năng lượng mặt trời thắp sáng suốt dọc tuyến cầu",
        "outcomeTextVi": "Con đường làng ban đêm sáng rực, an toàn cho mọi người qua lại.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -15,
        "intellectDelta": 15,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_21_traditional_craft_revival",
    "stageKey": "adulthood",
    "age": 38,
    "titleVi": "Phục Dựng Làng Nghề Gốm Sứ / Mộc Truyền Thống",
    "descriptionVi": "Làng nghề thủ công cổ truyền quê bạn đứng trước nguy cơ mai một do thiếu đầu ra.",
    "category": "career",
    "choices": [
      {
        "id": "adul_21_a",
        "textVi": "Ứng dụng thương mại điện tử đưa sản phẩm thủ công mỹ nghệ xuất khẩu quốc tế",
        "outcomeTextVi": "Làng nghề hồi sinh mạnh mẽ, giá trị văn hóa dân tộc được vinh danh khắp năm châu.",
        "healthDelta": -5,
        "happinessDelta": 35,
        "wealthDelta": 45,
        "intellectDelta": 25,
        "relationsDelta": 35,
        "careerTag": "Nghệ Nhân Bảo Tồn Di Sản"
      },
      {
        "id": "adul_21_b",
        "textVi": "Tổ chức các lớp truyền nghề miễn phí cho thanh niên trong làng",
        "outcomeTextVi": "Thế hệ trẻ tiếp nối giữ lửa cho làng nghề ngàn năm văn hiến.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 15,
        "intellectDelta": 20,
        "relationsDelta": 35,
        "addVirtue": "Tâm huyết giữ gìn bản sắc và di sản nghề thủ công truyền thống"
      }
    ]
  },
  {
    "id": "adul_22_sacramental_marriage_jubilee",
    "stageKey": "adulthood",
    "age": 36,
    "titleVi": "Kỷ Niệm 10 Năm Hôn Phối Trong Ơn Chúa",
    "descriptionVi": "Một thập kỷ cùng nhau vượt qua thăng trầm, hai vợ chồng dâng Thánh Lễ tạ ơn Bí Tích Hôn Phối.",
    "category": "faith",
    "requiredReligion": "catholic",
    "choices": [
      {
        "id": "adul_22_a",
        "textVi": "Nhắc lại lời cam kết yêu thương và xin Chúa chúc lành cho chặng đường kế tiếp của Bí Tích Hôn Phối",
        "outcomeTextVi": "Tình cảm vợ chồng đằm thắm, gương sáng gia đình Công giáo đạo đức lan tỏa.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 0,
        "intellectDelta": 10,
        "relationsDelta": 35,
        "addVirtue": "Một lòng chung thủy trọn tình nghĩa vợ chồng theo thánh ý Chúa"
      },
      {
        "id": "adul_22_b",
        "textVi": "Cùng các con thực hiện một chuyến hành hương gia đình tạ ơn",
        "outcomeTextVi": "Kỷ niệm thiêng liêng in sâu vào tâm khảm các con từ thuở nhỏ.",
        "healthDelta": 10,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_23_health_longevity_run",
    "stageKey": "adulthood",
    "age": 39,
    "titleVi": "Giải Chạy Cự Ly Đầy Đủ 42km Full Marathon",
    "descriptionVi": "Thử thách khắc nghiệt thử thách sức bền và ý chí của tuổi cận 40.",
    "category": "health",
    "choices": [
      {
        "id": "adul_23_a",
        "textVi": "Vượt qua ngưỡng kiệt sức ở km 35 và cán đích với nụ cười rạng rỡ",
        "outcomeTextVi": "Bạn nhận huy chương Finisher danh giá, chứng minh sức mạnh thể chất và tinh thần tuyệt vời.",
        "healthDelta": 25,
        "happinessDelta": 35,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 15,
        "unlockAchievement": "Chinh Phục 42km Marathon"
      },
      {
        "id": "adul_23_b",
        "textVi": "Duy trì tốc độ ổn định, hoàn thành cự ly an toàn bảo vệ khớp gối",
        "outcomeTextVi": "Chiến thuật khôn ngoan giúp bạn duy trì phong độ thể thao đỉnh cao lâu dài.",
        "healthDelta": 20,
        "happinessDelta": 25,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 15
      }
    ]
  },
  {
    "id": "adul_24_mentoring_teenager",
    "stageKey": "adulthood",
    "age": 39,
    "titleVi": "Đồng Hành Cùng Con Bước Vào Tuổi Dậy Thì",
    "descriptionVi": "Con lớn bước vào tuổi 11-12 với những thay đổi tâm sinh lý và những thắc mắc về cuộc sống.",
    "category": "family",
    "choices": [
      {
        "id": "adul_24_a",
        "textVi": "Làm bạn cùng con, kiên nhẫn lắng nghe và chia sẻ chân thành không phán xét",
        "outcomeTextVi": "Con tin tưởng tâm sự mọi điều, gia đình vượt qua tuổi dậy thì nhẹ nhàng, êm ấm.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35,
        "addVirtue": "Lắng nghe nhẫn nại và làm bạn cùng con cái trên đường đời"
      },
      {
        "id": "adul_24_b",
        "textVi": "Đưa con cùng tham gia các hoạt động thể thao dã ngoại cuối tuần",
        "outcomeTextVi": "Tình cha con/mẹ con khăng khít, con phát triển thể chất và tinh thần lành mạnh.",
        "healthDelta": 15,
        "happinessDelta": 30,
        "wealthDelta": -5,
        "intellectDelta": 10,
        "relationsDelta": 30
      }
    ]
  },
  {
    "id": "adul_25_community_library",
    "stageKey": "adulthood",
    "age": 37,
    "titleVi": "Tủ Sách Bác Ái Vùng Xa",
    "descriptionVi": "Bạn gom góp hơn 2.000 đầu sách hay gửi tặng các điểm trường tiểu học vùng cao biên giới.",
    "category": "society",
    "choices": [
      {
        "id": "adul_25_a",
        "textVi": "Tự mình lên vùng cao trao tận tay các em học sinh từng cuốn sách thơm mùi giấy mới",
        "outcomeTextVi": "Ánh mắt lấp lánh của các em nhỏ xua tan mọi mệt nhọc của chuyến đi dài.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -15,
        "intellectDelta": 15,
        "relationsDelta": 30,
        "addVirtue": "Trao tặng ánh sáng tri thức cho trẻ em vùng biên cương nghèo khó"
      },
      {
        "id": "adul_25_b",
        "textVi": "Xây dựng mạng lưới tình nguyện viên duy trì luân chuyển sách định kỳ",
        "outcomeTextVi": "Dự án lan tỏa bền vững, mang lại tri thức cho hàng ngàn học trò nghèo.",
        "healthDelta": 0,
        "happinessDelta": 30,
        "wealthDelta": -10,
        "intellectDelta": 20,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "adul_26_clean_energy_home",
    "stageKey": "adulthood",
    "age": 38,
    "titleVi": "Lắp Điện Mặt Trời Áp Mái & Sống Xanh",
    "descriptionVi": "Bạn đầu tư hệ thống pin năng lượng mặt trời và hệ thống phân loại rác hữu cơ tại gia đình.",
    "category": "society",
    "choices": [
      {
        "id": "adul_26_a",
        "textVi": "Chủ động dùng năng lượng sạch, giáo dục con cái tình yêu thiên nhiên và tạo hóa",
        "outcomeTextVi": "Hóa đơn tiền điện giảm về 0, lối sống xanh lan tỏa sang các nhà láng giềng.",
        "healthDelta": 10,
        "happinessDelta": 25,
        "wealthDelta": 20,
        "intellectDelta": 15,
        "relationsDelta": 25,
        "addVirtue": "Ý thức bảo vệ môi trường và trân trọng công trình tạo dựng của Thiên Chúa"
      },
      {
        "id": "adul_26_b",
        "textVi": "Tạo khu vườn rau sạch trên sân thượng cung cấp rau sạch cho gia đình",
        "outcomeTextVi": "Bữa cơm hàng ngày tươi ngon, an toàn vệ sinh thực phẩm.",
        "healthDelta": 15,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 10,
        "relationsDelta": 20
      }
    ]
  },
  {
    "id": "adul_27_peace_in_trials",
    "stageKey": "adulthood",
    "age": 40,
    "titleVi": "Bình An Giữa Biến Cố Thử Thách",
    "descriptionVi": "Một biến cố bất ngờ xảy ra trong công việc đe dọa sự nghiệp bạn gầy dựng suốt 15 năm.",
    "category": "career",
    "choices": [
      {
        "id": "adul_27_a",
        "textVi": "Bình thản đón nhận, cầu nguyện xin ơn khôn ngoan và kiên định xử lý từng vướng mắc",
        "outcomeTextVi": "Sự điềm tĩnh lạ thường giúp bạn lội ngược dòng ngoạn mục, bảo toàn danh dự và uy tín.",
        "healthDelta": 5,
        "happinessDelta": 25,
        "wealthDelta": 10,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "addVirtue": "Bình tâm vững chí và phó thác cậy trông khi đối diện nghịch cảnh"
      },
      {
        "id": "adul_27_b",
        "textVi": "Luôn có sự đồng lòng, chia sẻ và nâng đỡ vô điều kiện từ người bạn đời",
        "outcomeTextVi": "Tình nghĩa phu thê càng sáng ngời như vàng ròng qua lửa đỏ.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "adul_28_investing_in_youth",
    "stageKey": "adulthood",
    "age": 40,
    "titleVi": "Đầu Tư Thiên Thần Cho Khởi Nghiệp Trẻ",
    "descriptionVi": "Bạn làm nhà đầu tư thiên thần cố vấn cho một nhóm kỹ sư trẻ phát triển thiết bị y tế thông minh.",
    "category": "career",
    "choices": [
      {
        "id": "adul_28_a",
        "textVi": "Cố vấn chiến lược bằng cả kinh nghiệm quản trị và đạo đức kinh doanh",
        "outcomeTextVi": "Sản phẩm thử nghiệm thành công, được đưa vào ứng dụng cứu sống bệnh nhân.",
        "healthDelta": 0,
        "happinessDelta": 35,
        "wealthDelta": 40,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "careerTag": "Nhà Cố Vấn Đầu Tư Uy Tín"
      },
      {
        "id": "adul_28_b",
        "textVi": "Nhắc nhở nhóm trẻ luôn đặt y đức và tính mạng con người lên trên lợi nhuận",
        "outcomeTextVi": "Nhóm khởi nghiệp tôn bạn là bậc tiền bối đức cao vọng trọng.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": 20,
        "intellectDelta": 20,
        "relationsDelta": 35,
        "addVirtue": "Dẫn dắt thế hệ trẻ lập nghiệp trên nền tảng lương tâm và đạo đức"
      }
    ]
  },
  {
    "id": "adul_29_family_reunion",
    "stageKey": "adulthood",
    "age": 40,
    "titleVi": "Ngày Hội Ngộ Dòng Họ Tứ Đại Đồng Đường",
    "descriptionVi": "Nhân dịp mừng thọ ông bà, dòng họ tổ chức ngày đại hội quy tụ hàng trăm con cháu từ khắp nơi về quê hương.",
    "category": "family",
    "choices": [
      {
        "id": "adul_29_a",
        "textVi": "Đứng ra tổ chức ghi chép lại gia phả dòng họ, tôn vinh truyền thống hiếu học",
        "outcomeTextVi": "Con cháu khắp nơi tự hào về gốc gác tổ tiên, gắn kết tình thân sâu nặng.",
        "healthDelta": 5,
        "happinessDelta": 35,
        "wealthDelta": -10,
        "intellectDelta": 15,
        "relationsDelta": 40,
        "addVirtue": "Gìn giữ gia phong, nối kết tình cảm dòng họ bền chặt ngàn đời"
      },
      {
        "id": "adul_29_b",
        "textVi": "Trao học bổng khuyến học cho tất cả các cháu đạt thành tích học tập xuất sắc",
        "outcomeTextVi": "Phong trào rèn đức luyện tài trong dòng họ bừng bừng khí thế.",
        "healthDelta": 5,
        "happinessDelta": 30,
        "wealthDelta": -20,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  },
  {
    "id": "adul_30_age40_reflection",
    "stageKey": "adulthood",
    "age": 40,
    "titleVi": "Tứ Thập Nhi Bất Hoặc — Cột Mốc Tuổi 40",
    "descriptionVi": "Tròn 40 tuổi, không còn hoang mang trước những cám dỗ phù hoa, bạn nhìn đời với sự thấu suốt và an nhiên.",
    "category": "society",
    "choices": [
      {
        "id": "adul_30_a",
        "textVi": "Dâng lời tạ ơn Thiên Chúa vì hồng ân sự sống, gia đình bình an và sự nghiệp vững vàng",
        "outcomeTextVi": "Tâm hồn ngập tràn sự thanh thản, sẵn sàng bước vào tuổi trung niên chín muồi.",
        "healthDelta": 10,
        "happinessDelta": 35,
        "wealthDelta": 10,
        "intellectDelta": 25,
        "relationsDelta": 30,
        "addVirtue": "Tâm hồn sâu sắc, sống trọn vẹn từng ngày trong tạ ơn và yêu thương"
      },
      {
        "id": "adul_30_b",
        "textVi": "Nắm tay người bạn đời cùng nhìn các con khôn lớn chơi đùa",
        "outcomeTextVi": "Hạnh phúc gia đình giản đơn chính là bến đỗ bình yên nhất trần gian.",
        "healthDelta": 10,
        "happinessDelta": 40,
        "wealthDelta": 0,
        "intellectDelta": 15,
        "relationsDelta": 35
      }
    ]
  }
];
